import { DESKTOP_COLLAPSE_MIN_WIDTH, DESKTOP_MIN_WIDTH } from 'constants';
import { useDetectDevice } from 'hooks/useDetectDevice';
import usePage from 'hooks/usePage';
import React from 'react';
import styled from 'styled-components';

const OuterBodyContent = ({ children }) => {
  const { isDashboardPage } = usePage();
  const { isDesktop } = useDetectDevice();

  const getBackgroundValue = () => {
    if (isDesktop) return 'transparent';
    if (isDashboardPage) return '#fcfcfc';
    return '#fff';
  };
  return (
    <OuterBodyContentStyled style={{ background: getBackgroundValue() }}>
      {children}
    </OuterBodyContentStyled>
  );
};

const OuterBodyContentStyled = styled.div`
  margin: 70px 0px 0px 0px;
  box-shadow: none;
  height: calc(100dvh - 70px);
  padding: 16px;
  position: relative;
  border-radius: 12px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    height: fit-content;
    margin: 96px 0 47px 0;
    padding: 0px;
  }
  @media screen and (min-width: ${DESKTOP_COLLAPSE_MIN_WIDTH}px) {
    margin: 96px 24px 47px 0;
  }
`;

export default OuterBodyContent;
